import React from "react";
import withRole from "../../../Providers/AuthProvider/WithRole";
import AddLocation from "../../../Containers/Location/AddLocation/AddLocation";

const EditLocationPage = () => {
    return (
        <div className="add-location-page">
            <AddLocation />
        </div>
    );
};

export default withRole(EditLocationPage, ["admin"]);
